import { TabPanelOptions } from '../../constants';

export const title = {
  [TabPanelOptions.CREATED_LISTS]: 'Checklists criadas',
  [TabPanelOptions.RECEIVED_LISTS]: 'Checklists recebidas',
};
